// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';
import { stopPropagationAndPreventDefault } from 'app/src/stopPropagationAndPreventDefault';
import { PopOver } from 'app/scripts/views/lib/PopOver';
import template from 'app/scripts/views/templates/member_on_card';
import React from 'react';
import {
  LazyProfileCard,
  LazyCardProfileCard,
} from 'app/src/components/ProfileCard';
import { Analytics, tracingCallback } from '@trello/atlassian-analytics';

const removeMemberFromCardFunction = (card, member) => {
  const source = 'cardMemberMenuInlineDialog';
  const traceId = Analytics.startTask({
    taskName: 'edit-card/idMembers',
    source,
  });

  card.removeMemberWithTracing(
    member.id,
    traceId,
    tracingCallback(
      {
        taskName: 'edit-card/idMembers',
        traceId,
        source,
      },
      () => {
        Analytics.sendUpdatedCardFieldEvent({
          field: 'idMembers',
          source,
          containers: {
            card: { id: card.id },
            board: { id: card.get('idBoard') },
            list: { id: card.get('idList') },
          },
          attributes: {
            taskId: traceId,
            changeType: 'remove member',
          },
        });
      },
    ),
  );
};

// eslint-disable-next-line @trello/enforce-variable-case
const CardViewHelpers = {
  openMemberOnCardMenu(e) {
    stopPropagationAndPreventDefault(e);

    const elem = $(e.target, this.$el).closest('.member');
    const idMem = elem.attr('data-idmem');
    const member = this.modelCache.get('Member', idMem);
    const card = this.model;

    PopOver.toggle({
      elem,
      reactElement: (
        <LazyCardProfileCard
          key="profile"
          // eslint-disable-next-line react/jsx-no-bind
          onClose={() => PopOver.hide()}
          memberId={member.id}
          cardId={card.id}
          // eslint-disable-next-line react/jsx-no-bind
          removeMemberFromCardOverride={() =>
            removeMemberFromCardFunction(card, member)
          }
        />
      ),
      hideHeader: true,
    });
  },

  openMemberOnAtMention(e) {
    stopPropagationAndPreventDefault(e);
    const board = this.model.getBoard();
    // Get member from DOM
    const elem = $(e.target, this.$el).closest('.atMention');
    const idMem = elem?.text()?.substring(1);
    const member = this.modelCache.findOne('Member', 'username', idMem);

    Analytics.sendUIEvent({
      action: 'clicked',
      actionSubject: 'mention',
      actionSubjectId: 'memberMention',
      source: 'cardDetailScreen',
      containers: {
        workspace: {
          id: board?.getOrganization()?.id,
        },
        board: {
          id: board?.id,
        },
        card: {
          id: this.model.id,
        },
      },
      attributes: {
        mentionedMemberId: member?.id,
      },
    });

    if (member) {
      PopOver.toggle({
        elem,
        reactElement: (
          <LazyProfileCard
            key="profile"
            // eslint-disable-next-line react/jsx-no-bind
            onClose={() => PopOver.hide()}
            memberId={member.id}
          />
        ),
        hideHeader: true,
      });
    }
  },

  getMemberOnCardHtml(member) {
    const data = member.toJSON();

    const board = this.model.getBoard();
    data.isVirtual =
      board?.getOrganization()?.isVirtual(member) || board?.isVirtual(member);
    data.isDeactivated = board?.isDeactivated(member);

    return template(data);
  },
};

export { CardViewHelpers };
